module.exports = __webpack_public_path__ + "img/video-a5.5ed1ae51.jpg";